import { useNavigate } from "react-router-dom";
import { BrandLockup } from "@/components/Branding";
import { StartFreeButton, Eyebrow } from "@/components/landing/shared";

const CHIPS = [
  { t: "Childhood", c: "#E06D53", pos: "left-2 top-6 -rotate-6" },
  { t: "Teenage years", c: "#8C6CB0", pos: "right-3 top-14 rotate-3" },
  { t: "Young Adult", c: "#4A8B6E", pos: "left-6 bottom-20 rotate-2" },
  { t: "Seniors", c: "#C85B7A", pos: "right-6 bottom-8 -rotate-3" },
];

export const LandingNav = () => {
  const navigate = useNavigate();
  return (
  <nav className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-4 sm:px-6 sm:py-5">
    <BrandLockup />
    <div className="flex items-center">
      <button
        data-testid="nav-sign-in"
        onClick={() => navigate("/account")}
        className="rounded-full border-2 border-[#36858B] px-5 py-2 text-sm font-semibold text-[#36858B] transition-colors hover:bg-[#36858B] hover:text-white"
      >
        Sign In
      </button>
    </div>
  </nav>
  );
};

export const HeroVision = () => (
  <header className="relative overflow-hidden">
    <div aria-hidden className="pointer-events-none absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[#F7C4B8]/40 blur-3xl" />
    <div aria-hidden className="pointer-events-none absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-[#C3E3E9]/50 blur-3xl" />
    <div className="relative mx-auto grid max-w-6xl items-center gap-12 px-5 pb-16 pt-6 sm:px-6 lg:grid-cols-[1.1fr_1fr] lg:pb-24">
      <div className="landing-rise">
        <Eyebrow>Your Life Journeys Matter</Eyebrow>
        <h1 data-testid="hero-title" className="mt-4 font-serif text-4xl leading-[1.08] tracking-tight text-[#2D2824] sm:text-5xl lg:text-6xl">
          Every life has memories <span className="italic text-[#E06D53]">worth preserving.</span>
        </h1>
        <p className="mt-6 max-w-xl text-base leading-relaxed text-[#6E665E] sm:text-lg">
          The laughter at a family table, a first best friend, the street you grew up on, the people who believed in you.
          Your Life Journeys Matter is a private, gentle place to record those moments — one season of life at a time —
          so the story only you can tell is never lost.
        </p>
        <div className="mt-8">
          <StartFreeButton testId="hero-start" className="w-full sm:w-auto" />
        </div>
        <p className="mt-4 text-sm text-[#948B80]">10 days free in the Childhood season · no card needed to begin</p>
      </div>
      <div className="relative mx-auto w-full max-w-md landing-rise [animation-delay:150ms]">
        <div className="overflow-hidden rounded-[28px] bg-[#2A392E] shadow-xl ring-8 ring-white">
          <img src="/brand/journal-path.webp" alt="An open journal with a golden path, leaves and stars rising from its pages" className="h-72 w-full object-cover sm:h-80" />
          <p className="px-6 pb-6 pt-2 font-['Caveat',cursive] text-2xl text-[#F2D493]">Begin with one memory…</p>
        </div>
        {CHIPS.map((ch) => (
          <span key={ch.t} className={`absolute hidden rounded-full px-3 py-1 text-xs font-semibold text-white shadow-md sm:block ${ch.pos}`} style={{ background: ch.c }}>
            {ch.t}
          </span>
        ))}
      </div>
    </div>
  </header>
);
